import { combineReducers } from 'redux-immutable'
import saleProductReducer from './sale-product-reducer'
import saleProductListReducer from './sale-product-list-reducer'
import saleProductCreateReducer from './sale-product-create-reducer'
import saleProductGetReducer from './sale-product-get-reducer'
import saleProductUpdateReducer from './sale-product-update-reducer'
import saleProductDeleteReducer from './sale-product-delete-reducer'
import saleProductExportReducer from './sale-product-export-reducer'
import saleProductManualReducer from './sale-product-manual-reducer'

export default combineReducers({
  saleProduct: saleProductReducer,
  saleProductList: saleProductListReducer,
  saleProductCreate: saleProductCreateReducer,
  saleProductGet: saleProductGetReducer,
  saleProductUpdate: saleProductUpdateReducer,
  saleProductDelete: saleProductDeleteReducer,
  saleProductExport: saleProductExportReducer,
  saleProductManual: saleProductManualReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/sale-product/index.js